<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="invFtyLocationCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span><span style="color: #303133">{{ row.hxSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayScmName="{ row }">
        <span>NC：</span><span style="color: #303133">{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
        <br />
        <span>BUYER：</span
        ><span style="color: #303133">{{ row.buyerName }}</span>
      </template>
      <template v-slot:displayLocationNo="{ row }">
        <span>{{ $l('form_placeholder_locationNo') || 库位编号 }}：</span
        ><span style="color: #303133">{{ row.locationNo }}</span>
        <br />
        <span>{{ row.ecomWarehouseName }}</span>
        <br />
        <span>{{ row.ecomWarehouseNameEn }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
